import { render, staticRenderFns } from "./VirtualAccount.vue?vue&type=template&id=88d63520&"
import script from "./VirtualAccount.vue?vue&type=script&lang=js&"
export * from "./VirtualAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports